import styles from './safe-area-spacer.module.scss';
export const SafeAreaSpacer = () => {
    return <div className={styles.safeAreaSpacer} />;
};
